import { botExemptionUAStrings } from '@/constants/botExemptionUAStrings';

export function isWebCrawler(userAgent = '') {
  const webCrawlerRegex = new RegExp(botExemptionUAStrings, 'i');
  return webCrawlerRegex.test(userAgent.toLocaleLowerCase());
}
